/**
 * Runtime configuration. Vite exposes VITE_* variables on import.meta.env.
 * ROUTER_MODE "hash" is used for static previews that cannot rewrite paths.
 */
const env: Record<string, string | undefined> = (import.meta as any).env ?? {};

export const APP_CONFIG = {
  brand: 'RDK',
  tagline: 'Digital Decoration. Made Personal.',
  routerMode: (env.VITE_ROUTER_MODE === 'hash' ? 'hash' : 'history') as 'hash' | 'history',
  apiBase: env.VITE_API_BASE ?? '/api',
  contact: {
    /** Shown as typed; the same number is used for calls, Viber, Telegram and WhatsApp. */
    phone: '093 946 75 25',
    /** International form without spaces, for tel: and messenger links. */
    phoneIntl: '+380939467525',
    city: 'Україна',
  },
} as const;

/** URL of a file in /public (works with history routing and relative previews). */
export function asset(path: string): string {
  return `${env.BASE_URL ?? '/'}${path}`;
}
